import { useStore } from 'vuex'

export default () => {
  const { commit } = useStore()

  function create (parsedData) {
    commit('addAttachment', parsedData.payload.value)
  }

  function deleteAttachment (parsedData) {
    commit('deleteAttachment', parsedData.payload.value)
  }

  function deleteMultipleAttachment (parsedData) {
    commit('deleteMultipleAttachment', parsedData.payload.value)
  }

  function updateName (parsedData) {
    commit('updateName', parsedData.payload.value)
  }

  function initAttachment (parsedData) {
    if (parsedData.payload.type === 'create') {
      create(parsedData)
    } else if (parsedData.payload.type === 'delete') {
      deleteAttachment(parsedData)
    } else if (parsedData.payload.type === 'deleteMultiple') {
      deleteMultipleAttachment(parsedData)
    } else if (parsedData.payload.type === 'updateName') {
      updateName(parsedData)
    }
  }
  return {
    initAttachment
  }
}
